import React, { forwardRef, type ForwardedRef } from 'react';
import { clsx } from 'clsx';
import './Switch.scss';

export interface ESSSwitchProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  /** Label for the switch */
  label?: React.ReactNode;
  /** Helper text to display below the switch */
  helperText?: string;
  /** Whether the switch is in an error state */
  isInvalid?: boolean;
  /** Error message to display when isInvalid is true */
  errorMessage?: string;
}

export const Switch = forwardRef<HTMLInputElement, ESSSwitchProps>(
  function Switch(
    { label, helperText, isInvalid, errorMessage, className, ...props },
    ref: ForwardedRef<HTMLInputElement>,
  ) {
    const switchClasses = clsx(
      'ess-switch',
      {
        'ess-switch--invalid': isInvalid,
      },
      className,
    );

    return (
      <label className={switchClasses}>
        <input
          ref={ref}
          type="checkbox"
          className="ess-switch__input"
          aria-invalid={isInvalid}
          {...props}
        />
        <span className="ess-switch__control" aria-hidden="true" />
        {label && <span className="ess-switch__label">{label}</span>}
        {(helperText || (isInvalid && errorMessage)) && (
          <span className="ess-switch__help-text">
            {isInvalid && errorMessage ? errorMessage : helperText}
          </span>
        )}
      </label>
    );
  },
);

Switch.displayName = 'ESSSwitch';
